"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ultraSwapService = exports.Severity = exports.AGGREGATOR_SOURCES = void 0;
exports.AGGREGATOR_SOURCES = {
    METIS: 'metis',
    JUPITERZ: 'jupiterz',
    HASHFLOW: 'hashflow',
    DFLOW: 'dflow',
};
var Severity;
(function (Severity) {
    Severity["INFO"] = "info";
    Severity["WARNING"] = "warning";
    Severity["CRITICAL"] = "critical";
})(Severity || (exports.Severity = Severity = {}));
class UltraSwapService {
    constructor() {
        this.BASE_URL = 'https://ultra-api.jup.ag';
        this.ROUTE = {
            SWAP: `${this.BASE_URL}/execute`,
            ORDER: `${this.BASE_URL}/order`,
            ROUTERS: `${this.BASE_URL}/order/routers`,
            BALANCES: `${this.BASE_URL}/balances`,
            SHIELD: `${this.BASE_URL}/shield`,
        };
    }
    getQuote(params, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParams = new URLSearchParams(Object.entries(params)
                .filter(([_, value]) => value !== undefined)
                .reduce((acc, [key, value]) => (Object.assign(Object.assign({}, acc), { [key]: value.toString() })), {}));
            const response = yield fetch(`${this.ROUTE.ORDER}?${queryParams.toString()}`, { signal });
            if (!response.ok) {
                throw response;
            }
            const result = yield response.json();
            return result;
        });
    }
    submitSwap(signedTransaction, requestId) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(this.ROUTE.SWAP, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ signedTransaction, requestId }),
            });
            if (!response.ok) {
                throw response;
            }
            const result = yield response.json();
            return result;
        });
    }
    getRouters() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(this.ROUTE.ROUTERS);
            if (!response.ok) {
                throw response;
            }
            const result = yield response.json();
            return result;
        });
    }
    getBalance(address, signal) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${this.ROUTE.BALANCES}/${address}`, { signal });
            if (!response.ok) {
                throw response;
            }
            const result = yield response.json();
            return result;
        });
    }
    getShield(mintAddress) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`${this.ROUTE.SHIELD}?mints=${mintAddress.join(',')}`);
            if (!response.ok) {
                throw response;
            }
            const result = yield response.json();
            return result;
        });
    }
}
exports.ultraSwapService = new UltraSwapService();
